/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'

// import BootstrapVue from "bootstrap-vue"
// Vue.use(BootstrapVue);

// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap-vue/dist/bootstrap-vue.css"
// import "@/assets/css/style.css"


import settings from './plugins/vue-tailwind';
import VueTailwind from 'vue-tailwind'
Vue.use(VueTailwind, settings);


Vue.config.productionTip = false

import Variables from '@/mixins/variables';
Vue.mixin(Variables)
import utils from '@/mixins/utils';
Vue.mixin(utils)

import VueLocalStorage from 'vue-localstorage';

Vue.use(VueLocalStorage, {
    name: 'ls',
    bind: true //created computed members from your variable declarations
})

import Auth from '@/js/Auth'
Vue.use(Auth);

window.axios = require('axios');
window.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

window.axios.interceptors.request.use(function(config){
    config.headers.Authorization =  'Bearer '+ Vue.auth.getToken()
    return config;
});

import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import vueSignature from "vue-signature"
Vue.use(vueSignature)

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import Router from 'vue-router'
import router from './router.js'
Vue.use(Router)

import store from './store/index';

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})